module.exports = __webpack_public_path__ + "static/media/2014-dan-anna.773d8d6c.jpg";